import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { HybridIframeManagerService, IFrameStyle } from '../services/hybrid-iframe-manager.service';
import { Observable, Subscription } from 'rxjs';

@Directive({
    selector: '[pHybridIframeContainer]'
})
export class HybridIframeContainerDirective implements OnDestroy, OnInit {
    @Input() relaunchObserver?: Observable<void>;
    private relaunchSubscription?: Subscription;

    constructor(private element: ElementRef, private iframeManager: HybridIframeManagerService) {
        iframeManager.setContainer(element.nativeElement);
    }

    ngOnDestroy(): void {
        this.iframeManager.clearContainer();
        this.iframeManager.clearCustomStyle();
        if (this.relaunchSubscription) {
            this.relaunchSubscription.unsubscribe();
        }
    }

    @Input() public set hybridIframeUrl(url: string) {
        this.iframeManager.setSourceUrl(url);
    }

    @Input() public set hybridIframeStyle(style: IFrameStyle) {
        this.iframeManager.setCustomStyle(style);
    }

    ngOnInit(): void {
        if (this.relaunchObserver) {
            this.relaunchSubscription = this.relaunchObserver.subscribe(() => {
                this.iframeManager.setContainer(this.element.nativeElement);
            });
        }
    }
}
